import updateAttachmentGroupInput from './common/update-attachment-group-input'
import updateAttachmentInOtherGroups from './common/update-attachment-in-other-groups'

function updateAttachments() {
  updateAttachmentGroupInput($(this).closest('table'))
  updateAttachmentInOtherGroups($(this))
}

export default () => {
  $(document).on(
    'change',
    '[data-behaviour="export-check-attachment"]',
    updateAttachments
  )

  return () => {
    $(document).off(
      'change',
      '[data-behaviour="export-check-attachment"]',
      updateAttachments
    )
  }
}
